var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VMSTextField',{attrs:{"id":_vm.id,"label":_vm.label,"placeholder":_vm.placeholder,"hint":_vm.hint,"rules":_vm.AllRules},on:{"input":_vm.onInput},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})
}
var staticRenderFns = []

export { render, staticRenderFns }